/**
 * 1Mind deployment constants (Thryv workspace).
 *
 * NATIVE COPY. This is a deliberate fork of legacy/src2/1mind/Config.js, not an import —
 * the legacy bundle stays frozen for legacy pages and this one is free to evolve with the
 * native theme. The cost is real: DEPLOYMENT IDS AND THE FIELD MAP EXIST IN BOTH PLACES.
 * When 1Mind changes an id, change it here AND in legacy/src2/1mind/Config.js (and, if the
 * connect bar's own copy is still in play, in src2/ThryvConnectBar/Config.js too).
 *
 * Ids come from the "Integration Phased Approach Overview" tab of the Thryv + 1mind
 * Integrations Worksheet.
 */

export const Config = {
  launcherBase: "https://launcher.1mind.com/",

  /**
   * 1Mind's own contract — the launcher mounts into an element with this id and nothing
   * else. Do not rename.
   */
  mountId: "onemind-widget",

  /**
   * Flip to "production" once 1Mind confirms the production deployments carry Thryv's
   * persona. Sandbox still serves their placeholder content ("Ask AI Name Goes Here").
   * Overridable per call.
   */
  env: "sandbox",

  deployments: {
    // Mounts inline into an element you provide.
    embedded: {
      sandbox: "deployment-fxmqjh5hsl",
      production: "deployment-95gk4pzs5j",
    },

    // Mounts its own fixed bottom-right overlay. Not used by page-level code — the
    // connect bar already owns that corner.
    widget: {
      sandbox: "deployment-6gsszb2hdw",
      production: "deployment-8td62jc9r9",
    },

    // Post-form-submit conversation, seeded with the values the visitor just typed
    // rather than the HubSpot cookie.
    behindTheForm: {
      sandbox: "deployment-9p7jfwsb6s",
      production: "deployment-96sdz7hmmr",
    },
  },
};

export default Config;
